//import 'lightgallery/dist/js/lightgallery.js'
// import 'lightgallery.js/src/js/lightgallery.js'
import 'lightgallery.js/dist/js/lightgallery'
import 'lg-zoom.js/dist/lg-zoom.js'
//import { lgZoom } from "lg-zoom.js"
// import { lightGallery } from "lightgallery";
// import { lgZoom } from "lg-zoom.js"

// const $gallery = $('.lightgallery')
// $gallery.lightGallery({
// 	selector: '.zoom',
// 	mode: 'lg-fade',
// 	enableDrag: false,
// 	zoom: true,
// 	hash: false,
// 	loop: true,
// 	counter: false,
// 	download: false,
// 	controls: true,
// 	thumbnail: false,
// 	hideBarsDelay: 1000000,
// 	getCaptionFromTitleOrAlt: false,
// })


const $gallery = document.getElementById('bd')
// const $zoom = jQuery('.lightgallery').attr('data-zoom')

// if ( "false" === jQuery('.lightgallery').attr('data-zoom') ) {
// 	const myzoom = false
// } else {
// 	const myzoom = true
// }

// console.log($zoom)
lightGallery($gallery, {
	selector: '.zoom',
	mode: 'lg-fade',
	enableDrag: false,
	zoom: true,
	actualSize: false,
	hash: false,
	loop: true,
	counter: false,
	download: false,
	controls: true,
	thumbnail: false,
	hideBarsDelay: 1000000,
	getCaptionFromTitleOrAlt: false,
}); 